import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MessagesModule } from '@app/messages/messages.module';
import { AngularMaterialModule } from '@app/shared/angular-material.module';
import { CargoModule } from '@cargo/cargo.module';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@shared/shared.module';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { EditOrderComponent } from './edit-order/edit-order.component';
import { MultiPubIssuesMatrixComponent } from './multi-pub-issues-matrix/multi-pub-issues-matrix.component';
import { OrderLineComponent } from './order-line/order-line.component';
import { OrderServiceComponent } from './order-service/order-service.component';
import { FindMaterialDialogComponent } from './order/find-material-dialog/find-material-dialog.component';
import { MaterialPreviewDialogComponent } from './order/material-preview-dialog/material-preview-dialog.component';
import { NewMaterialDialogComponent } from './order/new-material-dialog/new-material-dialog.component';
import { OrderMaterialPanelComponent } from './order/order-material-panel/order-material-panel.component';
import { OrderComponent } from './order/order.component';
import { PublisherPriceSummaryDialogComponent } from './order/publisher-price-summary-dialog/publisher-price-summary-dialog.component';
import { ExportReportModal } from './order/report/modal/export.report.modal';
import { SortByKeyAndReturnValuesPipe } from './pipes/sort-by-key-and-return-values.pipe';
import { SelectIssuesComponent } from './select-issues/select-issues.component';
import { SelectPackageComponent } from './select-package/select-package.component';
import { SelectPlacementCategoryComponent } from './select-placement-category/select-placement-category.component';
import { SelectPlacementComponent } from './select-placement/select-placement.component';
import { SelectStyleComponent } from './select-style/select-style.component';
import { OrderHistoryDialogComponent } from '@order/order/order-history-dialog/order-history-dialog.component';

@NgModule({
	declarations: [
		EditOrderComponent,
		MultiPubIssuesMatrixComponent,
		OrderComponent,
		OrderLineComponent,
		SelectIssuesComponent,
		SelectPackageComponent,
		SelectPlacementCategoryComponent,
		SelectPlacementComponent,
		SelectStyleComponent,
		ExportReportModal,
		OrderServiceComponent,
		ExportReportModal,
		PublisherPriceSummaryDialogComponent,
		OrderMaterialPanelComponent,
		MaterialPreviewDialogComponent,
		FindMaterialDialogComponent,
		SortByKeyAndReturnValuesPipe,
  		OrderHistoryDialogComponent,
		NewMaterialDialogComponent,
	],
	imports: [
		AngularMaterialModule,
		CargoModule,
		CommonModule,
		FormsModule,
		MessagesModule,
		ReactiveFormsModule,
		SharedModule,
		TranslateModule,
		NgxMatSelectSearchModule,
	]
})
export class OrderModule { }
